import React from 'react';
import {connect} from 'react-redux';
import {OnNotEligiblePageLoad,NotEligibleCancel} from './../../components/SiteCat/SiteCat'
import {getMerchantData,unProcessableEntity} from './../../constants/merchantData';

class NoEligibleCard extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }
  
  componentWillMount = () => {
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode
    });
  }
  
  componentDidMount() {
    OnNotEligiblePageLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      cancelUrlData
    });
  }
  handleCancel = event => {
    NotEligibleCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }

  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div class="no-eligible-header">{merchantData.NoEligibleCard.HEADER}</div>
            <div class="no-eligible-section">{merchantData.NoEligibleCard.MESSAGE}</div>
            <div class="no-eligible-cancel"><button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.NoEligibleCard.LINK}</button></div>
          </div>
        </div>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(NoEligibleCard);